<template>
  <div id="app">
    <DataSummary></DataSummary>
  </div>
</template>

<script>
import DataSummary from '@/components/DataSummary'

export default {
  name: 'App',
  components: {
    DataSummary
  }
}
</script>

<style>
.herring-video-container {
  max-width: 700px;
  margin: 0 auto;
}
.herring-btn-lg {
  font-size: 1.5em;
  font-weight: 800;
  padding: .5rem 1rem;
}
.video-js {
  border-radius: 0px 0px 8px 8px;
}
</style>
